import { Formik, FormikHelpers } from "formik";
import {
  useFormSubmit,
  ControlcenterMelcoModelsSupplierProduct,
} from "melco-shared-logic";
import { useQueryClient } from "react-query";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplaySupplierProductAddForm } from "./DisplaySupplierProductAddForm";
import { useAddSupplierProduct } from "../../../hooks/supplierproducts/useAddSupplierProduct";

type SupplierProductAddFormProps = {
  isSupplierProductDrawerOpen: boolean;
  closeDrawerAction: () => void;
  // supplierProduct: ControlcenterMelcoModelsSupplierProduct;
};

type SupplierProductAddFormValueType = {
  name: string;
  code: string;
  supplier_id: string;
};

export const supplierProductToInitialValues = (
  supplierProduct: ControlcenterMelcoModelsSupplierProduct
) => {
  const { name, code, supplier_id } = supplierProduct;

  const initialValues: SupplierProductAddFormValueType = {
    name: name ?? "",
    code: code ?? "",

    supplier_id: supplier_id,
  };

  return initialValues;
};

export const SupplierProductAddForm: React.FC<SupplierProductAddFormProps> = ({
  closeDrawerAction,
}) => {
  const queryClient = useQueryClient();
  const queryKey = ["supplierProductAdd"];
  const addSupplierProductDraft = useAddSupplierProduct();

  const onSubmit = async (
    values: SupplierProductAddFormValueType,
    formikHelpers: FormikHelpers<SupplierProductAddFormValueType>
  ) => {
    await onSave(values, formikHelpers, { isManuallyResettingForm: true });
  };

  const handleSave = async (
    values: SupplierProductAddFormValueType,
    formikHelpers: FormikHelpers<SupplierProductAddFormValueType>,
    options: {}
  ) => {
    const { name, code, supplier_id } = values;

    let newEntity = await addSupplierProductDraft({
      code: code,
      name: name,
      supplier_id: supplier_id,
    });

    // update ui with new data
    formikHelpers.resetForm({
      values: supplierProductToInitialValues(newEntity!),
    });
    queryClient.setQueryData(queryKey, newEntity);
    closeDrawerAction();
  };

  const formSubmit = () => {
    return [
      async (
        values: SupplierProductAddFormValueType,
        formikHelpers: FormikHelpers<SupplierProductAddFormValueType>
      ) => {
        return handleSave(values, formikHelpers, {});
      },
      {
        translationPrefix: ["managesupplierProducts.actions", "add"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onSave = useFormSubmit(...formSubmit());

  const initialValues: SupplierProductAddFormValueType = {
    name: "",
    supplier_id: "",
    code: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
    >
      <DirtyFormPrompt>
        <DisplaySupplierProductAddForm />
      </DirtyFormPrompt>
    </Formik>
  );
};
